module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/not-alloted-refund/not-alloted-refund.component.css
// module id = ./src/app/allocation/not-alloted-refund/not-alloted-refund.component.css
// module chunks = main